import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c66b545"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lost-found-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "info-text" }, "분실물 안내", -1 /* HOISTED */))
const _hoisted_3 = { class: "search-wrapper" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "opacity-area" }, null, -1 /* HOISTED */))
const _hoisted_5 = { class: "modal-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "분실물센터" }, {
          rightButton: _withCtx(() => [
            ($setup.lostAndFoundGuideUrl)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "right-btn",
                  type: "button",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.toggleShowLostFoundGuide(true)))
                }, [
                  _createVNode($setup["InlineSvg"], {
                    src: require('@/assets/icons/help_circle.svg')
                  }, null, 8 /* PROPS */, ["src"]),
                  _hoisted_2
                ]))
              : _createCommentVNode("v-if", true)
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode($setup["SegmentedControl"], {
          segments: $setup.segmentTitles,
          initialIndex: 0,
          onOnChangedSegmentIndex: $setup.updateSegmentIndex
        }, null, 8 /* PROPS */, ["segments"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode($setup["SearchInput"], {
            class: "search",
            name: "분실물센터",
            placeholder: "물품명, 노선명, 특이사항 등으로 검색하세요",
            value: $setup.searchKeyword,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (($setup.searchKeyword) = $event)),
            delayMilliSeconds: 0,
            onOnEnter: $setup.resetAndGetLostFoundList,
            onClearText: $setup.clearSearchKeyword
          }, null, 8 /* PROPS */, ["value"]),
          _hoisted_4
        ]),
        _createCommentVNode(" 분실물/습득물 목록 "),
        _createElementVNode("div", {
          class: "lost-found-list",
          ref: "listContainer",
          onScroll: $setup.handleScroll
        }, [
          _withDirectives(_createVNode($setup["LostList"], {
            lostList: $setup.lostList,
            onOnClickRow: $setup.goToLostOrFoundDetail,
            role: "tabpanel",
            id: `segment-panel-${$setup.getSegmentIndex($setup.LostFoundTypeCode.Lost)}`,
            "aria-labelledby": `segment-tab-${$setup.getSegmentIndex(
            $setup.LostFoundTypeCode.Lost
          )}`,
            "aria-hidden": $setup.selectedSegment.type !== $setup.LostFoundTypeCode.Lost
          }, null, 8 /* PROPS */, ["lostList", "id", "aria-labelledby", "aria-hidden"]), [
            [_vShow, $setup.selectedSegment.type === $setup.LostFoundTypeCode.Lost]
          ]),
          _withDirectives(_createVNode($setup["FoundList"], {
            foundList: $setup.foundList,
            onOnClickRow: $setup.goToLostOrFoundDetail,
            role: "tabpanel",
            id: `segment-panel-${$setup.getSegmentIndex($setup.LostFoundTypeCode.Found)}`,
            "aria-labelledby": `segment-tab-${$setup.getSegmentIndex(
            $setup.LostFoundTypeCode.Found
          )}`,
            "aria-hidden": $setup.selectedSegment.type !== $setup.LostFoundTypeCode.Found
          }, null, 8 /* PROPS */, ["foundList", "id", "aria-labelledby", "aria-hidden"]), [
            [_vShow, $setup.selectedSegment.type === $setup.LostFoundTypeCode.Found]
          ])
        ], 544 /* NEED_HYDRATION, NEED_PATCH */),
        ($setup.selectedSegment.type === $setup.LostFoundTypeCode.Lost)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn-apply",
              onClick: $setup.onClickLostCreateBtn
            }, " 분실물 신고하기 "))
          : _createCommentVNode("v-if", true)
      ]),
      ($setup.listContainer)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            container: $setup.listContainer
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true),
      _createVNode($setup["PageModal"], {
        shouldShow: $setup.shouldShowLostFoundGuide,
        onBackHandler: () => $setup.toggleShowLostFoundGuide(false)
      }, {
        default: _withCtx(() => [
          _createVNode($setup["LostFoundGuide"], {
            onOnClickClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowLostFoundGuide(false)))
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["shouldShow", "onBackHandler"]),
      ($setup.shouldShowDailyWritingCountLimitModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 1,
            title: "작성 횟수 초과",
            okButtonTitle: "확인",
            onOnClickOkButton: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleShowDailyWritingCountLimitModal(false)))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_5, [
                _createTextVNode(" 하루에 최대 " + _toDisplayString($setup.maxDailyLostFoundCreationCount ?? "-") + "개의 게시물만 작성할 수 있습니다.", 1 /* TEXT */),
                _hoisted_6,
                _createTextVNode(" 내일 다시 시도해 주세요. ")
              ])
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}